const EXIT_REASON_LABELS = {
  just_browsing: "Estava apenas conhecendo",
  pay_later: "Pretende pagar depois",
  price: "Achou o valor alto",
  need_more_information: "Precisa de mais informações",
  payment_method: "Não encontrou a forma de pagamento",
  technical_issue: "Encontrou um problema técnico",
  unknown: "Não informou o motivo",
};

const FIELD_LABELS = {
  full_name: "nome completo",
  name: "nome",
  email: "e-mail",
  cpf: "CPF",
  phone: "telefone",
  card_number: "número do cartão",
  expiry: "validade do cartão",
  expiration_date: "validade do cartão",
  security_code: "código de segurança",
  cvv: "código de segurança",
  postal_code: "CEP",
  unknown: "dados do formulário",
};

const METHOD_LABELS = {
  pix: "Pix",
  card: "Cartão",
  credit_card: "Cartão",
  unknown: "Pagamento",
};

export const PERIOD_OPTIONS = [
  { value: 1, label: "Hoje" },
  { value: 7, label: "7 dias" },
  { value: 30, label: "30 dias" },
];

const formatLocalDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export function buildDateRange(days, now = new Date()) {
  const safeDays = Math.max(1, Number(days) || 1);
  const end = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const start = new Date(end);
  start.setDate(start.getDate() - (safeDays - 1));

  return {
    start_date: formatLocalDate(start),
    end_date: formatLocalDate(end),
  };
}

export function getPreviousStepRate(current, previous) {
  const currentValue = Number(current) || 0;
  const previousValue = Number(previous) || 0;
  if (previousValue <= 0 || currentValue > previousValue) return null;
  return Math.round((currentValue / previousValue) * 100);
}

export function getExitReasonLabel(reason) {
  return EXIT_REASON_LABELS[reason] || String(reason || "Outro motivo").replaceAll("_", " ");
}

export function getValidationErrorLabel(error = {}) {
  const method = METHOD_LABELS[error.method] || error.method || "Pagamento";
  const field = FIELD_LABELS[error.field] || error.field || "dados informados";
  return `${method}: revisar ${field}`;
}

export function getOperationalMessage(summary = {}) {
  const providerErrors = Number(summary.leads_com_erro_provedor) || 0;
  const validationErrors = Number(summary.leads_com_erro_validacao) || 0;
  const checkoutExits = Number(summary.leads_com_saida_checkout) || 0;
  const completed = getConfirmedBuyerCount(summary);
  const paymentViews = Number(summary.leads_com_payment_view) || 0;

  if (providerErrors > 0) {
    return {
      tone: "error",
      title: "Há pagamentos que precisam de atenção",
      description: `${providerErrors} ${providerErrors === 1 ? "pessoa encontrou" : "pessoas encontraram"} erro ao tentar pagar.`,
    };
  }

  if (validationErrors > 0 || checkoutExits > 0) {
    return {
      tone: "warning",
      title: "Algumas pessoas não concluíram",
      description: "Veja abaixo onde elas pararam e quem pode precisar de ajuda.",
    };
  }

  if (completed > 0) {
    return {
      tone: "success",
      title: "Os pagamentos estão avançando",
      description: `${completed} ${completed === 1 ? "pagamento foi concluído" : "pagamentos foram concluídos"} no período.`,
    };
  }

  if (paymentViews > 0) {
    return {
      tone: "info",
      title: "Há pessoas avaliando a assinatura",
      description: "Elas abriram o pagamento, mas ainda não concluíram.",
    };
  }

  return {
    tone: "neutral",
    title: "Ainda não houve movimento neste período",
    description: "Tente ampliar o período para acompanhar mais dados.",
  };
}

export function getConfirmedBuyerCount(summary = {}) {
  if (summary.compradores_com_pagamento_confirmado != null) {
    return Number(summary.compradores_com_pagamento_confirmado) || 0;
  }
  return Number(summary.leads_com_pagamento_concluido) || 0;
}
